import React from "react";

export default function TemplateDefinitionView(props) {
  const {
    templateData,
    setTemplateData,
    defaultDate,
    isReady,
    isProcessing,
    onCreate,
    infraStatus,
  } = props;

  // Handle local state updates for the DTO
  const handleChange = (field, value) => {
    setTemplateData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <div className="card shadow-sm border-0 mt-4">
      <div className="card-body p-4">
        {/* 🎯 Section 3 Title: Matching Font, Size, and Color of Section 1 & 2 */}
        <label className="small fw-bold text-muted mb-3 d-block text-uppercase">
          3. Template Definition
        </label>

        <div className="row g-3">
          {/* Template Name (Read-Only, derived from Source File) */}
          <div className="col-md-6">
            <label className="small fw-bold text-muted d-block mb-1 text-uppercase">
              Template Name
            </label>
            <input
              type="text"
              className="form-control bg-light shadow-none"
              value={templateData.name || ""}
              readOnly
            />
          </div>

          {/* Status (Uneditable DRAFT) */}
          <div className="col-md-6">
            <label className="small fw-bold text-muted d-block mb-1 text-uppercase">
              Status
            </label>
            <input
              type="text"
              className="form-control bg-light fw-bold text-primary shadow-none"
              value={templateData.status || "DRAFT"}
              readOnly
            />
          </div>

          {/* Description (Required) */}
          <div className="col-12">
            <label className="small fw-bold text-muted d-block mb-1 text-uppercase">
              Description <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control shadow-none border-primary-subtle"
              rows="2"
              placeholder="Enter template purpose or reporting scope..."
              value={templateData.description}
              onChange={(e) => handleChange("description", e.target.value)}
            ></textarea>
          </div>

          {/* Valid From Date Picker */}
          <div className="col-md-6">
            <label className="small fw-bold text-muted d-block mb-1 text-uppercase">
              Valid From
            </label>
            <input
              type="date"
              className="form-control shadow-none"
              /* 🎯 FIX: Use 'value' instead of 'defaultValue' to reflect hydrated state */
              value={templateData.validFrom || defaultDate}
              onChange={(e) => handleChange("validFrom", e.target.value)}
            />
          </div>

          {/* Action Area */}
          <div className="col-md-6 d-flex align-items-end">
            <button
              className={`btn btn-lg w-100 fw-bold shadow-sm ${
                isReady && !infraStatus
                  ? "btn-primary"
                  : "btn-outline-secondary disabled"
              }`}
              disabled={!isReady || isProcessing || !!infraStatus}
              onClick={onCreate}
            >
              {isProcessing ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  PROVISIONING...
                </>
              ) : infraStatus ? (
                "STRUCTURE VERIFIED"
              ) : (
                "CREATE TEMPLATE STRUCTURE"
              )}
            </button>
          </div>
        </div>

        {/* Infrastructure Feedback (Hidden unless provisioned) */}
        {infraStatus && (
          <div className="mt-3 p-3 bg-success bg-opacity-10 border border-success border-opacity-25 rounded">
            <div className="small text-success fw-bold text-uppercase mb-1">
              Infrastructure Provisioned
            </div>
            <div className="small text-muted text-truncate">
              <strong>Root Path:</strong> {infraStatus.root_path}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
